import { useGetQRCodeQuery } from '@src/services/esim/esimApiSlice';
import React, { useEffect, useState } from 'react';

const QRCode: React.FC<{ esimId?: string; className?: string }> = ({
  esimId,
  className,
}) => {
  const [qrCodeUrl, setQrCodeUrl] = useState<string | null>(null);

  const { data: QRCode } = useGetQRCodeQuery(
    {
      esimId: esimId!,
    },
    { skip: !esimId }
  );

  useEffect(() => {
    if (QRCode) {
      const blobUrl = URL.createObjectURL(QRCode);
      setQrCodeUrl(blobUrl);

      return () => URL.revokeObjectURL(blobUrl);
    }
    return undefined;
  }, [QRCode]);

  return (
    qrCodeUrl && (
      <div className='flex items-center justify-center w-[168px] h-[168px]'>
        <img src={qrCodeUrl} className={className} alt='QR Code' />
      </div>
    )
  );
};

export default QRCode;
